import Modal from '../modal';

import './styles.css';
import Logo from '../images/logo.jpg';

export const Step4ReviewSession = ({
  onNext,
  latestTournament,
  isButtonLoading
}) => {
  return (
    <Modal className="review-session-step-4">
      <img src={Logo} alt="Logo" className="onboarding-logo" />
      <h2>You’re all set!</h2>
      <h1>Review Session Overview</h1>
      <ul>
        <li><b>Rounds:</b> We’ve set {latestTournament?.round_count} round{latestTournament?.round_count > 1 ? 's' : ''} where you’ll run 1 exercise per round.</li>
        <li><b>Assign Exercises:</b> You’ll need to assign an exercise to each round, but review first and deselect any irrelevant accounts or transactions.</li>
        <li><b>Team Play:</b> Students play individually; scores combine for the team.</li>
        <li><b>Team Merge:</b> Losing teams join winners (except Championship).</li>
      </ul>
      <button 
        className={`button onboarding-big-button ${isButtonLoading ? 'loading' : ''}`}
        onClick={onNext}
      >
        {!isButtonLoading && 'View Competition'}
      </button>
    </Modal>
  )
};